<script setup lang="ts">
import { usePwaInstall } from '../composables/usePwaInstall';

const { showInstallButton, installPwa } = usePwaInstall();
</script>

<template>
  <div v-if="showInstallButton" class="install-prompt" @click="installPwa">
    <div class="prompt-content">
      <span>App installieren</span>
      <button class="close-button" @click.stop="showInstallButton = false">×</button>
    </div>
  </div>
</template>

<style scoped>
.install-prompt {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: #960040;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  cursor: pointer;
}

.prompt-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.close-button {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 0 4px;
}
</style>